import type { Product } from '../types';

const ProductKeyToHAMSMap: Record<Product, string> = {
	['jira']: 'jira-software',
	['jira-service-management']: 'jira-servicedesk',
	['jira-product-discovery']: 'jira-product-discovery',
	['confluence']: 'confluence',
	['jira-customer-service']: 'jira-customer-service',
};

/**
 * When querying AGG for entitlements we need to pass through the `hamsProductKey` which is
 * a specific key used to identify the product, we're just mapping our product keys to those
 * hams keys for queries
 */
export const getHamsKey = (product: Product): string => {
	return ProductKeyToHAMSMap[product];
};
